<template>
  <div>
    <!-- <div class="mainTitle">商品管理</div> -->
    <el-card v-auth="'/goodsInfo/pageList'">
      <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth">
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="4">
            <el-cascader style="width: 100%" clearable collapse-tags v-model="courseIds" :show-all-levels="false" :props="subjectTreeProps" placeholder="请输入所属科目" :options="subjectTreeList" @change="subjectSearchChange"></el-cascader>
          </el-col>
          <el-col :sm="24" :md="12" :lg="4">
            <el-input v-model="searchForm.name" placeholder="请输入商品名称" auto-complete="off" clearable></el-input>
          </el-col>
          <el-col :sm="24" :md="12" :lg="4">
            <el-select v-model="searchForm.sell" style="width: 100%">
              <el-option label="全部" value></el-option>
              <el-option label="上架" value="1"></el-option>
              <el-option label="下架" value="-1"></el-option>
            </el-select>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-date-picker style="width: 100%" v-model="createTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" @change="timeChange"></el-date-picker>
          </el-col>
          <el-col :sm="24" :md="6" :lg="6" style="float: right">
            <div style="float: right">
              <!-- <a class="mainColor" @click="reset">重置</a> -->
              <el-button type="primary" @click="; (page.pageNumber = 1), pageList()" icon="el-icon-search">查询</el-button>
            </div>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="12" style="float:right">
            <div style="float:right">
              <a class="mainColor" @click="reset">重置</a>
              <el-button type="primary" @click="pageList" icon="el-icon-search">查询</el-button>
            </div>
          </el-col>
        </el-row>-->
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px">
      <el-row :gutter="20">
        <div :key="goodsNum" style="
            float: left;
            font-weight: bolder;
            line-height: 40px;
            color: #4e4e4e;
            margin-left: 10px;
          ">
          商品数量：{{ page.total }}
        </div>
        <el-col :sm="24" :md="12" :lg="12" style="float: right">
          <el-button-group style="float: right">
            <el-button type="primary" @click="addGoods(1)" icon="el-icon-plus" v-auth="'/goodsInfo/addGoods'">新建商品</el-button>
            <el-button type="primary" @click="goodsBatchOff" v-auth="'/goodsInfo/goodsBatchOff'">批量下架</el-button>
            <el-button type="primary" @click="goodsBatchOn" v-auth="'/goodsInfo/goodsBatchOn'">批量上架</el-button>
            <!-- <el-button type="danger" @click="batchDeleteGoodsInfo" icon="el-icon-minus">批量删除</el-button> -->
          </el-button-group>
        </el-col>
      </el-row>
      <el-table ref="multipleTable" :data="page.rows" tooltip-effect="dark" style="margin-top: 20px; width: 100%" border @selection-change="selectionChange" v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(255, 255, 255, 0.8)">
        <el-table-column type="selection" min-width="40"></el-table-column>

        <el-table-column prop="name" label="商品" align="center" show-overflow-tooltip width="260px">
          <template slot-scope="row">
            <div style="display: flex">
              <img style="width: 120px; height: 60px" :src="
                row.row.logo
                  ? row.row.logo
                  : 'http://ncszhgj.oss-cn-hangzhou.aliyuncs.com/tkwx/15743276279534477403800.png'
              " />
              <div style="margin-left: 10px; width: 130px">
                <!-- <span style="color:rgb(106,224,105)" v-if="row.row.recommend=='1'">{{"[推荐]"}}</span>
                <span style="color:rgb(106,224,105)" v-if="row.row.hot=='1'">{{"[热门]"}}</span>-->
                <!-- <span style="color:rgb(77,145,225)">{{row.row.name}}</span> -->
                <span>{{ row.row.name }}</span>
                <span style="display: block">
                  <span style="color: red">￥{{ row.row.price }}</span>
                  <span style="
                      text-decoration: line-through;
                      color: rgb(162, 170, 188);
                    ">￥{{ row.row.originalPrice }}</span>
                </span>
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="agentPrice" align="center" label="结算价" width="100px"> -->
        <el-table-column prop="validDay" align="center" show-overflow-tooltip label="有效期" width="100px">
          <template slot-scope="row">{{
              row.row.validDay ? row.row.validDay + '天' : '不限'
          }}</template>
        </el-table-column>
        <!-- <el-table-column prop="postponeDay" label="延期天数" min-width="8%">
          <template slot-scope="row">{{row.row.postponeDay==""?"-":row.row.postponeDay}}天</template> -->
        <!-- </el-table-column> -->
        <el-table-column prop="subjectCourseName" show-overflow-tooltip label="所属科目" width="200px"></el-table-column>
        <el-table-column prop="type" label="类型" show-overflow-tooltip :render-header="renderSpecNameHeader" width="90px" align="center">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.type" placement="top" effect="light">
              <div style="
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                ">
                {{ scope.row.type }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip width="100px" align="center" prop="goodsItemCount" label="内容">
          <template slot-scope="row">
            <el-button @click="goodsItem(row.row)" type="text">{{
                row.row.goodsItemCount
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="sell" label="上架" align="center" width="80px">
          <template slot-scope="row">
            <el-switch v-model="row.row.sell" active-value="1" inactive-value="-1" @change="updateSwitching(row)" class="switchStyle" active-text="开" inactive-text="关"></el-switch>
          </template>
        </el-table-column>
        <!-- <el-table-column show-overflow-tooltip prop="sellCount" label="真实销量" align="center" width="80px">
          <template slot-scope="row">
            <el-button @click="goodsNumber(row.row.id)" type="text">{{
                row.row.actualSellCount == null ? 0 : row.row.actualSellCount
              }}
            </el-button>
          </template>
        </el-table-column> -->
        <el-table-column show-overflow-tooltip prop="validDay" label="上架时间" min-width="150px" align="center">
          <template slot-scope="row">{{ row.row.onTime }}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="validDay" label="失效时间" min-width="150px" align="center">
          <template slot-scope="row">
            <span v-if="row.row.offTime == null">不限</span>
            <span v-else>不限</span>
          </template>
        </el-table-column>

        <el-table-column show-overflow-tooltip label="操作" width="140px" align="center">
          <template slot-scope="scope">
            <div class="operationGroup" style="z-index: 100">
              <i v-auth="'/goodsInfo/editGoods'" class="el-icon-edit icon-style" title="编辑" @click="editGoods(scope.row)"></i>
              <span @click="copyGoods(scope.row)" v-auth="'/goodsInfo/copyGoodsInfoCenter'">复制</span>
              <!-- <i class="el-icon-delete icon-style" title="删除" @click="deleteGoodsInfo(scope.row)"></i> -->
              <i v-auth="'/goodsInfo/getGoodsInfo'" class="el-icon-view mainColor" style="font-size: 20px" title="查看" @click="goGoodsInfo(scope.row)"></i>
              <!-- <i class="iconfont icon-qian mainColor" title="代理价" @click="openEdit(scope.row)"></i> -->
              <!--  <span @click="goodsAgentPrice(scope.row.id)">代理价</span>-->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination v-if="!loading" background @size-change="sizeChange" @current-change="currentChange" :page-sizes="[10, 20, 30, 40]" :current-page="page.pageNumber" style="margin-top: 20px; text-align: right" :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.total"></el-pagination>
    </el-card>
    <el-dialog title="设置代理价" :visible.sync="agentPriceVisible" width="450px" left>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="name" label="代理类型" width="180"></el-table-column>
        <el-table-column prop="price" label="代理价（元）" width="180">
          <template slot-scope="row">
            <el-input v-model="row.row.price" placeholder="请输入代理价格"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="agentPriceVisible = false">取 消</el-button>
        <el-button type="primary" @click="addGoodsAgentPriceBatch">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="编辑代理价" :visible.sync="editVisible" width="400px" left>
      <el-form :label-width="formLabelWidth" v-if="editForms.length > 0">
        <el-row :span="24">
          <div class="zhao-center">
            <div style="
                color: #455a64;
                font-weight: bold;
                font-size: 14px;
                width: 50%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              ">
              商品名:{{ editFormsList.name }}
            </div>

            <div style="
                color: #455a64;
                font-weight: bold;
                font-size: 14px;
                text-align: right;
                width: 50%;
              ">
              商品价格:{{ editFormsList.price }}
            </div>
          </div>
        </el-row>
        <el-row :span="24" style="margin: 10px 0">
          <el-col :sm="6" :md="6" :lg="6">
            <div>代理等级</div>
          </el-col>

          <el-col :sm="9" :md="9" :lg="9">
            <div>代理价格</div>
          </el-col>
        </el-row>
        <div v-if="editForms != null && editForms.length > 0">
          <el-row :span="24" v-for="(item, index) in editForms" :key="index">
            <div class="zhao-center" style="justify-content: space-between; margin-bottom: 10px">
              <div class="zhao-center" :style="`width:20%;height:32px;color:#fff;background-color: ${item.color}`">
                {{ item.name }}
              </div>
              <el-input style="width: 76%" size="small" v-model="item.price" placeholder>
                <template slot="append">
                  <span class="mainColor">元</span>
                </template>
              </el-input>
            </div>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="editVisible = false">取 消</el-button>
        <el-button type="primary" @click="closeDialog2">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SelectHeader from "./SelectHeader";

export default {
  data () {
    return {
      paginationBlock: false,
      goodsNum: 0,
      tableData: [],
      editForms: [],
      addgoodsAgentPrice: {},
      agentPriceVisible: false,
      editVisible: false,
      subjectTreeList: [], //科目
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
        multiple: true,
      },
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      createTime: "",
      courseIds: [],
      searchForm: {
        sell: "",
        subjectIds: [],
        onTimeBegin: "",
        onTimeEnd: "",
        name: "",
      },
      editFormsList: {},
      addForm: {
        name: "",
        logo: "",
        recommend: "",
        hot: "",
        sell: "",
        validDay: "",
        tags: "",
        courseId: "",
        postpone: "",
        postponeDay: "",
        sellCount: "",
        price: "",
        originalPrice: "",
        summary: "",
        detail: "",
      },
      addFormRules: {
        name: [
          {
            required: true,
            message: "请输入商品名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 100,
            message: "商品名称长度在1到100个字",
          },
        ],
        logo: [
          {
            required: true,
            message: "请输入图标",
            trigger: "blur",
          },
          {
            min: 1,
            max: 300,
            message: "图标长度在1到300个字",
          },
        ],
        recommend: [
          {
            required: true,
            message: "请输入是否推荐",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否推荐格式不正确",
          },
        ],
        hot: [
          {
            required: true,
            message: "请输入是否热门",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否热门格式不正确",
          },
        ],
        sell: [
          {
            required: true,
            message: "请输入是否上架",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否上架格式不正确",
          },
        ],
        validDay: [
          {
            required: true,
            message: "请输入有效天数",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "有效天数格式不正确",
          },
        ],
        tags: [
          {
            required: true,
            message: "请输入标签",
            trigger: "blur",
          },
          {
            min: 1,
            max: 1000,
            message: "标签长度在1到1000个字",
          },
        ],
        courseId: [
          {
            required: true,
            message: "请输入科目id-第二级分类",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "科目id-第二级分类格式不正确",
          },
        ],
        postpone: [
          {
            required: true,
            message: "请输入是否支持延期",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否支持延期格式不正确",
          },
        ],
        postponeDay: [
          {
            required: true,
            message: "请输入延期天数",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "延期天数格式不正确",
          },
        ],
        sellCount: [
          {
            required: true,
            message: "请输入销量",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "销量格式不正确",
          },
        ],
        price: [
          {
            required: true,
            message: "请输入价格",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "价格格式不正确",
          },
        ],
        originalPrice: [
          {
            required: true,
            message: "请输入原始价格",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "原始价格格式不正确",
          },
        ],
        summary: [
          {
            required: true,
            message: "请输入摘要",
            trigger: "blur",
          },
          {
            min: 1,
            max: 1000,
            message: "摘要长度在1到1000个字",
          },
        ],
        detail: [
          {
            required: true,
            message: "请输入详细介绍",
            trigger: "blur",
          },
          {
            min: 1,
            max: 65535,
            message: "详细介绍长度在1到65535个字",
          },
        ],
      },
      editForm: {
        name: "",
        logo: "",
        recommend: "",
        hot: "",
        sell: "",
        validDay: "",
        tags: "",
        courseId: "",
        postpone: "",
        postponeDay: "",
        price: "",
        originalPrice: "",
        summary: "",
        detail: "",
      },
      editFormRules: {
        name: [
          {
            required: true,
            message: "请输入商品名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 100,
            message: "商品名称长度在1到100个字",
          },
        ],
        logo: [
          {
            required: true,
            message: "请输入图标",
            trigger: "blur",
          },
          {
            min: 1,
            max: 300,
            message: "图标长度在1到300个字",
          },
        ],
        recommend: [
          {
            required: true,
            message: "请输入是否推荐",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否推荐格式不正确",
          },
        ],
        hot: [
          {
            required: true,
            message: "请输入是否热门",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否热门格式不正确",
          },
        ],
        sell: [
          {
            required: true,
            message: "请输入是否上架",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否上架格式不正确",
          },
        ],
        validDay: [
          {
            required: true,
            message: "请输入有效天数",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "有效天数格式不正确",
          },
        ],
        tags: [
          {
            required: true,
            message: "请输入标签",
            trigger: "blur",
          },
          {
            min: 1,
            max: 1000,
            message: "标签长度在1到1000个字",
          },
        ],
        courseId: [
          {
            required: true,
            message: "请输入科目id-第二级分类",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "科目id-第二级分类格式不正确",
          },
        ],
        postpone: [
          {
            required: true,
            message: "请输入是否支持延期",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否支持延期格式不正确",
          },
        ],
        postponeDay: [
          {
            required: true,
            message: "请输入延期天数",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "延期天数格式不正确",
          },
        ],
        price: [
          {
            required: true,
            message: "请输入价格",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "价格格式不正确",
          },
        ],
        originalPrice: [
          {
            required: true,
            message: "请输入原始价格",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "原始价格格式不正确",
          },
        ],
        summary: [
          {
            required: true,
            message: "请输入摘要",
            trigger: "blur",
          },
          {
            min: 1,
            max: 1000,
            message: "摘要长度在1到1000个字",
          },
        ],
        detail: [
          {
            required: true,
            message: "请输入详细介绍",
            trigger: "blur",
          },
          {
            min: 1,
            max: 65535,
            message: "详细介绍长度在1到65535个字",
          },
        ],
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      fileAction: `${process.env.BASE_URL}/goodsInfo/upload`,
      fileList: [],
      loading: true,
      updatePageId: "",
      goodsId: "",
      updatePageGoodsItem: "",
    };
  },
  methods: {
    openEdit (item) {
      this.editVisible = true;
      this.editFormsList = item;
      this.goodsId = item.id;
      this.api.agentLevel
        .getAgentPriceByGoodsId({ goodsId: item.id })
        .then((result) => {
          if (result.success) {
            this.editForms = result.data;
            this.editForms.forEach((items) => {
              if (items.goodsAgentPrice == null) {
                this.$set(items, "price", null);
              } else {
                this.$set(items, "price", items.goodsAgentPrice.price);
              }
            });
          } else {
            this.$message.error(result.message);
          }
        });
    },
    closeDialog2 () {
      let obj = [];
      // console.log("this.editForms",this.editForms)
      this.editForms.forEach((item) => {
        if (
          item.goodsAgentPrice == null ||
          item.goodsAgentPrice == "undefined"
        ) {
          if (item.price == null) {
            obj.push({
              goodsId: this.goodsId,
              agentLevelId: item.id,
            });
          } else {
            obj.push({
              goodsId: this.goodsId,
              agentLevelId: item.id,
              price: item.price.toString(),
            });
          }
        } else {
          if (item.price == null || item.price == "") {
            obj.push({
              id: item.goodsAgentPrice.id,
              agentLevelId: item.id,
              goodsId: this.goodsId,
            });
          } else {
            obj.push({
              id: item.goodsAgentPrice.id,
              goodsId: this.goodsId,
              agentLevelId: item.id,
              price: item.price.toString(),
            });
          }
        }
      });
      this.api.goodsAgentPrice
        .updateGoodsAgentPriceByBatch(obj)
        .then((result) => {
          if (result.success) {
            this.editVisible = false;
            this.pageList();
            this.$message.success(result.message);
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    goGoodsInfo (row) {
      this.$router.push({
        path: "/goGoodsInfo",
        query: {
          id: row.id,
        },
      });
    },
    goodsItem (row) {
      this.updatePageGoodsItem = row.id;
      this.$router.push({
        path: "/goodsItems",
        query: {
          updatePageGoodsItem: this.updatePageGoodsItem,
          subjectId: row.subjectId,
          goodsId: row.id,
          addWay: 1,
        },
      });
    },
    goodsNumber (row) {
      this.$router.push({
        path: "/goodsNumber",
        query: { goodsId: row },
      });
    },
    getAgentLevelList () {
      this.tableData = [];
      this.api.goodsAgentPrice.getAgentLevelList().then((result) => {
        this.tableData = result.data;
        for (let i in result.data) {
          delete this.tableData[i].createTime;
          delete this.tableData[i].enabled;
          delete this.tableData[i].grade;
          delete this.tableData[i].logo;
          delete this.tableData[i].remark;
          delete this.tableData[i].state;
          delete this.tableData[i].updateTime;
        }
      });
    },
    goodsAgentPrice (vId) {
      this.goodsId = vId;

      this.tableData = [];
      this.api.goodsAgentPrice.getAgentLevelList().then((result) => {
        this.tableData = result.data;
        for (let i in result.data) {
          delete this.tableData[i].createTime;
          delete this.tableData[i].enabled;
          delete this.tableData[i].grade;
          delete this.tableData[i].logo;
          delete this.tableData[i].remark;
          delete this.tableData[i].state;
          delete this.tableData[i].updateTime;
        }
        this.api.goodsAgentPrice
          .getGoodsAgentPriceList({ goodsId: vId })
          .then((result) => {
            for (let i in result.data) {
              for (let item in this.tableData) {
                if (result.data[i].agentLevelId == this.tableData[item].id) {
                  //this.tableData[item].price = result.data[i].price;
                  this.$set(
                    this.tableData[item],
                    "price",
                    result.data[i].price
                  );
                }
              }
            }
            // console.log("this.tableData", this.tableData);
            this.agentPriceVisible = true;
          });
      });
    },
    addGoodsAgentPriceBatch () {
      for (let i in this.tableData) {
        this.tableData[i].goodsId = this.goodsId;
        this.tableData[i].agentLevelId = this.tableData[i].id;
        delete this.tableData[i].id;
        delete this.tableData[i].name;
      }
      this.api.goodsAgentPrice
        .addGoodsAgentPriceBatch(this.tableData)
        .then((result) => {
          if (result.success) {
            this.agentPriceVisible = false;
            this.$message.success(result.message);
            this.pageList();
          } else {
            this.$message.error(result.message);
          }
        });
    },
    copyGoods (row) {
      // row.id;
      //    调接口
      this.$confirm('确认复制该商品吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.api.goodsAgentPrice
          .copyGoodsInfoCenter({
            goodsId: row.id
          })
          .then((result) => {
            console.log(result);
            if (result.success) {
              this.$message.success(result.message);
              this.pageList();
            } else {
              this.$message.error(result.message);
            }
          });

      });
    },
    editGoods (row) {
      this.updatePageId = row.id;
      this.$router.push({
        path: "/editGoodsTaocan",
        query: {
          updatePageId: this.updatePageId,
        },
      });
    },
    renderSpecNameHeader (createElement, { column, $index }) {
      let self = this;

      //该列的绑定数据
      // console.log(column);
      //列号
      // console.log($index);

      return createElement(
        "div",
        {
          style: "display:flex;padding:0px",
        },
        [
          createElement("div", {
            domProps: {
              innerHTML: column.label,
            },
          }),
          createElement(SelectHeader, {
            style: "cursor: pointer;",
            // 组件 prop
            props: {
              type: "specId",
              options: self.specIdOptions, //下拉框选项
              defaultValue: self.specId, //默认值
              defaultProps: {
                value: "specId",
                label: "specName",
              },
            },
            // 事件监听器在 `on` 属性内，
            // 但不再支持如 `v-on:keyup.enter` 这样的修饰器。
            // 需要在处理函数中手动检查 keyCode。
            on: {
              selectChange: self.selectChange,
              // click: this.clickHandler
            },
            // 仅用于组件，用于监听原生事件，而不是组件内部使用
            // `vm.$emit` 触发的事件。
            nativeOn: {
              // click: this.nativeClickHandler
            },
          }),
        ]
      );
    },
    //选择框回调
    selectChange (val) {
      // console.log(val);
      this.searchForm.type = val;
      this.pageList();
      //写点啥吧
    },
    timeChange () {
      if (this.createTime) {
        this.searchForm.onTimeBegin = this.createTime[0];
        this.searchForm.onTimeEnd = this.createTime[1];
      } else {
        this.searchForm.onTimeBegin = "";
        this.searchForm.onTimeEnd = "";
      }
    },
    subjectSearchChange () {
      if (this.courseIds) {
        this.searchForm.subjectIds = [];
        this.courseIds.forEach((item) => {
          this.searchForm.subjectIds.push(item[1]);
        });
      } else {
        this.searchForm.subjectIds = [];
      }
      // console.log(this.searchForm.subjectIds);
    },
    getSubjectTreeList () {
      // 获取课程
      this.api
        .getSubjectTreeList({ menuId: 2 })
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                delete items.children;
                // if (items.children.length != 0) {
                //   for (let itemss of items.children) {
                //     delete itemss.children;
                //   }
                // } else {
                //   // delete items.children;
                // }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addGoods (sty) {
      if (sty) {
        this.$router.push({
          path: "/addGoodsTaocan",
        });
      } else {
        this.$router.push({
          path: "/addGoodsTiku",
        });
      }
    },
    goToCommodityCenter (sty) {
      this.$router.push({
        path: "/commodityCenter",
      });
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange (val) {
      this.ids = [];
      this.multipleSelection = val;
      val.map((e) => this.ids.push(e.id));
    },
    //获取数据
    getGoodsInfo () {
      // console.log("11111111111", this.$route.query.updatePage);
      this.api.goodsInfo
        .getGoodsInfo({
          id: this.$route.query.updatePage,
        })
        .then((result) => {
          this.editForm = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    goodsBatchOn () {
      if (!this.ids.length) {
        this.$message({
          type: "error",
          message: "请选择需要上架的商品",
        });
        return;
      }
      this.api.goodsInfo
        .goodsBatchOn({ idList: this.ids })
        .then((result) => {
          if (result.success) {
            this.$message({
              type: "success",
              message: result.message,
            });
            this.pageList();
          } else {
            this.$message({
              type: "error",
              message: result.message,
            });
            this.pageList();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    goodsBatchOff () {
      if (!this.ids.length) {
        this.$message({
          type: "error",
          message: "请选择需要下架的商品",
        });
        return;
      }
      this.api.goodsInfo
        .goodsBatchOff({ idList: this.ids })
        .then((result) => {
          if (result.success) {
            this.$message({
              type: "success",
              message: result.message,
            });
            this.pageList();
          } else {
            this.$message({
              type: "error",
              message: result.message,
            });
            this.pageList();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    pageList (val) {
      // if (typeof val == "string") {
      //   this.searchForm.type = val;
      // } else {
      //   this.searchForm.type = "";
      // }
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.goodsInfo
        .pageList(this.searchForm)
        .then((result) => {
          this.page.rows = result.data.records;
          for (let i in this.page.rows) {
            this.page.rows[i].sell = String(this.page.rows[i].sell);
          }
          this.$set(this.page, "total", result.data.total);
          this.goodsNum += 1;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    addGoodsInfo () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.api.goodsInfo
            .addGoodsInfo(this.addForm)
            .then((result) => {
              this.addFormVisible = false;
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateSwitching (row) {
      // console.log(row.row.sell);
      this.ids[0] = row.row.id;
      if (row.row.sell == 1) {
        this.goodsBatchOn();
      } else {
        this.goodsBatchOff();
      }
    },
    updateGoodsInfo () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.api.goodsInfo
            .updateGoodsInfo(this.editForm)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteGoodsInfo (row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.goodsInfo
            .deleteGoodsInfo([
              {
                id: row.id,
              },
            ])
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    batchDeleteGoodsInfo () {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.goodsInfo
            .deleteGoodsInfo(this.ids)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    reset () {
      this.loading = true;
      this.$refs.searchForm.resetFields();
      this.createTime = [];
      this.courseIds = [];
      this.searchForm = {
        sell: "1",
        subjectIds: [],
        onTimeBegin: "",
        onTimeEnd: "",
        name: "",
      };
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      };
      this.pageList();
    },
    handleSuccess (response, file, fileList, $event) {
      this.importForm = response.data;
    },
    exportExcel () {
      this.loading = true;
      this.api.goodsInfo
        .exportExcel(this.searchForm)
        .then((result) => {
          location.href = result.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    importData () {
      this.api.goodsInfo
        .importData(this.importForm.rows)
        .then((result) => {
          this.$message({
            type: "success",
            message: result.message,
          });
          this.pageList();
          this.importFormVisible = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  computed: {
    reqData () {
      return this.$store.state.user;
    },
  },
  activated () {
    this.pageList();
  },
  watch: {
    addFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
    },
    editFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getGoodsInfo();
      }
    },
  },
  mounted () {
    this.pageList();
    this.getSubjectTreeList();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/goods/index.vue